import i18n from "multitenancy/i18n";

import { IAudience } from "./interface";

type statusType = {
  status: string;
  type: "waiting" | "warning" | "success" | "error";
};

const t = (key: string) => i18n.t(key);

export function status(code: string): statusType {
  switch (code) {
    case "A":
      return {
        status: t("audiences.status.scheduled"),
        type: "waiting",
      };
    case "I":
      return {
        status: t("audiences.status.scheduled"),
        type: "waiting",
      };
    case "G":
      return {
        status: t("audiences.status.inProgress"),
        type: "warning",
      };
    case "Q":
      return {
        status: t("audiences.status.publishing"),
        type: "success",
      };
    case "P":
      return {
        status: t("audiences.status.published"),
        type: "success",
      };
    case "C":
      return {
        status: t("audiences.status.cancelledFemale"),
        type: "error",
      };
    case "D":
      return {
        status: t("audiences.status.downloading"),
        type: "warning",
      };
    case "U":
      return {
        status: t("audiences.status.uploading"),
        type: "warning",
      };
    case "S":
      return {
        status: t("audiences.status.processing"),
        type: "warning",
      };
    case "E":
      return {
        status: t("audiences.status.closed"),
        type: "success",
      };
    case "L":
      return {
        status: t("audiences.status.notifying"),
        type: "warning",
      };
    case "N":
      return {
        status: t("audiences.status.notified"),
        type: "success",
      };
    case "X":
      return {
        status: t("audiences.status.notificationError"),
        type: "error",
      };
    default:
      return {
        status: t("audiences.status.invalid"),
        type: "error",
      };
  }
}

export function statusRecorded(code: number): statusType {
  switch (code) {
    case 10:
      return {
        status: t("audiences.status.scheduled"),
        type: "waiting",
      };
    case 11:
      return {
        status: t("audiences.status.starting"),
        type: "warning",
      };
    case 12:
      return {
        status: t("audiences.status.inProgress"),
        type: "warning",
      };
    case 13:
      return {
        status: t("audiences.status.finished"),
        type: "success",
      };
    case 14:
      return {
        status: t("audiences.status.error"),
        type: "error",
      };
    case 15:
      return {
        status: t("audiences.status.cancelledMale"),
        type: "error",
      };
    case 16:
      return {
        status: t("audiences.status.processing"),
        type: "warning",
      };
    case 17:
      return {
        status: t("audiences.status.downloading"),
        type: "warning",
      };
    case 18:
      return {
        status: t("audiences.status.uploading"),
        type: "warning",
      };
    case 19:
      return {
        status: t("audiences.status.processingJoin"),
        type: "warning",
      };
    case 20:
      return {
        status: t("audiences.status.unified"),
        type: "warning",
      };
    case 21:
      return {
        status: t("audiences.status.joinError"),
        type: "warning",
      };
    case -50:
      return {
        status: t("audiences.status.processTest"),
        type: "warning",
      };
    default:
      return {
        status: t("audiences.status.scheduled"),
        type: "waiting",
      };
  }
}

export function ticksToTime(ticks: number) {
  const totalSeconds = Math.floor(ticks / 10000000);
  let hours = Math.floor(totalSeconds / 3600);
  let minutes = Math.floor((totalSeconds % 3600) / 60);
  let seconds = totalSeconds % 60;
  const leftoverTicks = ticks % 10000000;
  if (leftoverTicks >= 6000000) {
    seconds++;
  }
  if (seconds >= 60) {
    seconds = 0;
    minutes++;
  }
  if (minutes >= 60) {
    minutes = 0;
    hours++;
  }
  return (
    hours?.toString().padStart(2, "0") +
    ":" +
    minutes?.toString().padStart(2, "0") +
    ":" +
    seconds?.toString().padStart(2, "0")
  );
}

function areAudiencesEqual(
  a?: any[] | null,
  b?: any[] | null
): boolean {
  if (!a && !b) return true;
  if (!a || !b) return false;
  if (a.length !== b.length) return false;

  const mapB = new Map<any, any>(b.map(x => [x.id, x]));
  for (const x of a) {
    const y = mapB.get(x.id);
    if (!y) return false;

    if (
      x.placeId !== y.placeId ||
      x.status !== y.status ||
      x.expectedDate !== y.expectedDate ||
      x.extraContent !== y.extraContent ||
      x.hearingTypeName !== y.hearingTypeName ||
      x.procedureNumber !== y.procedureNumber
    ) {
      return false;
    }
  }
  return true;
}

export function areEqual(
  prev: any,
  next: any
) {
  if (prev.placeId !== next.placeId) return false;
  if (prev.principalLabel !== next.principalLabel) return false;
  if (prev.backgroundHeader !== next.backgroundHeader) return false;
  if (prev.disabledFilter !== next.disabledFilter) return false;
  if (prev.isFilter !== next.isFilter) return false;
  if (prev.isLoading !== next.isLoading) return false;
  if (prev.totalCount !== next.totalCount) return false;
  if (prev.currentPage !== next.currentPage) return false;
  if (prev.pageCount !== next.pageCount) return false;

  if (prev.audienceSelected?.id !== next.audienceSelected?.id) return false;

  if (!areAudiencesEqual(prev.audiences as IAudience[], next.audiences as IAudience[])) {
    return false;
  }

  return true;
}
